export default {
  Accept: 'Accept',
  'Add other products': 'Add other products',
  Attachments: 'Attachments',
  All: 'All',
  Application: 'Application',
  'Article Information Sheet': 'Article Information Sheet',
  'Asia Pacific Region': 'Asia Pacific Region',
  'as your end date.': 'as your end date.',
  'as your start date.': 'as your start date.',
  Back: 'Back',
  Blog: 'Blog',
  By: 'By',
  'Catalog / Reorder Number: ': 'Catalog / Reorder Number: ',
  'Change Locale': 'Change Locale',
  Choose: 'Choose',
  'Choose current plate type': 'Choose current plate type',
  'Choose your desired currency.': 'Choose your desired currency.',
  'Clear all': 'Clear all',
  Close: 'Close',
  'Close calendar': 'Close calendar',
  'Close keyboard shortcuts menu': 'Close keyboard shortcuts menu',
  'Close Menu': 'Close Menu',
  'Close popup': 'Close popup',
  'Close this panel': 'Close this panel',
  'Cookie Preferences': 'Do Not Sell My Personal Information/Opt Out of Targeted Advertisings',
  'Cookie Settings': 'Do Not Sell My Personal Information/Opt Out of Targeted Advertisings',
  Comments: 'Comments',
  Company: 'Company',
  Confirm: 'Confirm',
  'CONTACT US FOR A MORE PRECISE ESTIMATE OF YOUR SAVINGS': 'CONTACT US FOR A MORE PRECISE ESTIMATE OF YOUR SAVINGS',
  Content: 'Content',
  Country: 'Country',
  'Country/Region - Language: ': 'Country/Region - Language: ',
  Currency: 'Currency',
  'Current plate price': 'Current plate price',
  CustomerStory: 'Customer Story',
  Date: 'Date',
  'Date and': 'Date and',
  'Date (Newest first)': 'Date (Newest first)',
  'Date (Oldest first)': 'Date (Oldest first)',
  'Escape key': 'Escape key',
  Email: 'Email',
  'Europe Region': 'Europe Region',
  'Enter key': 'Enter key',
  'Estimate Savings': 'Estimate Savings',
  'Event Details': 'Event Details',
  Events: 'Events',
  Filters: 'Filters',
  'First Name': 'First Name',
  'Footer Navigation': 'Footer Navigation',
  'Footer Quick Links': 'Footer Quick Links',
  'Get Substrate List': 'Get Substrate List',
  'Go to the first or last day of a week.': 'Go to the first or last day of a week.',
  'Hide caption': 'Hide caption',
  'High-chemistry plate': 'High-chemistry plate',
  Home: 'Home',
  'Home or End keys': 'Home or End keys',
  Honeypot: "Please don't fill out this field",
  'is required.': 'is required.',
  'Kodak Logo': 'Kodak Logo',
  'Last Name': 'Last Name',
  'Left or right arrow keys': 'Left or right arrow keys',
  'List View': 'List View',
  'List View selected': 'List View selected',
  'Listen to all episodes on SoundCloud': 'Listen to all episodes on SoundCloud',
  'Listen to this episode on SoundCloud': 'Listen to this episode on SoundCloud',
  'Learn More': 'Learn More',
  'Learn more': 'Learn more',
  'Learn more about': 'Learn more about',
  'Leaving site header': 'You are now leaving Kodak.com',
  'Leaving site redirect message': 'You will be automatically redirected to a third-party website managed by a Kodak licensee.',
  'Loading...': 'Loading...',
  Location: 'Location',
  Logo: 'Logo',
  'Log into your Account': 'Log into your Account',
  'Low-chemistry plate': 'Low-chemistry plate',
  'Media - Play': 'Media - Play',
  'More resources': 'More resources',
  'Move backward (left) and forward (right) by one day.': 'Move backward (left) and forward (right) by one day.',
  'Move backward to switch to the previous month.': 'Move backward to switch to the previous month.',
  'Move backward (up) and forward (down) by one week.': 'Move backward (up) and forward (down) by one week.',
  'Move forward to switch to the next month.': 'Move forward to switch to the next month.',
  'Next Page': 'Next page',
  'NEXT MONTH': 'NEXT MONTH',
  'NEXT WEEK': 'NEXT WEEK',
  'Next Slide': 'Next Slide',
  'Navigate to Home': 'Navigate to Home',
  'No': 'No',
  'No results were returned.': 'No results were returned.',
  'Not available.': 'Not available.',
  'Open Dropdown': 'Open Dropdown',
  'Open keyboard shortcuts menu.': 'Open keyboard shortcuts menu.',
  'Open media in popup overlay': 'Open media in popup overlay',
  'Open this panel': 'Open this panel',
  'PageUp and PageDown keys': 'PageUp and PageDown keys',
  'Photo Gallery': 'Photo Gallery',
  'PLATE VOLUME / MONTH': 'PLATE VOLUME / MONTH',
  Plates: 'Plates',
  'Plates used per year': 'Plates used / year',
  'Please enter a number': 'Please enter a number',
  'Please enter a valid email address.': 'Please enter a valid email address.',
  'Please enter a valid phone number.': 'Please enter a valid phone number.',
  'Please enter a valid ZIP code.': 'Please enter a valid ZIP code.',
  'Please enter text.': 'Please enter text.',
  'Please enter your company name.': 'Please enter your company name.',
  'Please enter your full first name.': 'Please enter your full first name.',
  'Please enter your full last name.': 'Please enter your full last name.',
  'Please enter the name of the country where your company is located.':
    'Please enter the name of the country where your company is located.',
  'Postal Code': 'Postal Code',
  'Press Kit': 'Press Kit',
  'Previous Page': 'Previous page',
  'Previous Slide': 'Previous Slide',
  'Pick a date': 'Pick a date',
  Price: 'Price',
  'Primary Navigation - Mobile': 'Primary Navigation - Mobile',
  'Primary Navigation': 'Primary Navigation',
  Products: 'Products',
  'Product Name / Keyword: ': 'Product Name / Keyword: ',
  'Product SDS': 'Product SDS',
  'Question mark': 'Question mark',
  'Read Article': 'Read Article',
  'Read The Story': 'Read The Story',
  'Redirect Now': 'Redirect Now',
  'Redirecting in': 'Redirecting in',
  'Redirecting now': 'Redirecting now...',
  'Reject Cookies': 'Reject Cookies',
  Register: 'Register',
  'Register for': 'Register for',
  'Related Links': 'Related Links',
  'Related Products': 'Related Products',
  'Report Category': 'Report Category',
  Reset: 'Reset',
  Search: 'Search',
  'Search page': 'Search page',
  'Search Placeholder': 'What are you looking for?',
  'Next page': 'Next page',
  'Previous page': 'Previous page',
  'seconds': 'seconds',
  'Select dates': 'Select dates',
  'Select Region': 'Select Region',
  'Select the date in focus': 'Select the date in focus',
  'Select Your Language': 'Select Your Language',
  'Selected.': 'Selected.',
  Share: 'Share',
  SHOP: 'SHOP',
  'Skip to main content': 'Skip to main content',
  'Sort by': 'Sort by',
  Specifications: 'Specifications',
  'Specifications for': 'Specifications for',
  Submit: 'Submit',
  'Switch months.': 'Switch months.',
  Table: 'Table',
  'THIS MONTH': 'THIS MONTH',
  'THIS WEEK': 'THIS WEEK',
  Tickets: 'Tickets',
  'Tile View': 'Tile View',
  'Tile View selected': 'Tile View selected',
  Time: 'Time',
  Timezone: 'Timezone',
  'Title (A-Z)': 'Title (A-Z)',
  'Title (Z-A)': 'Title (Z-A)',
  TODAY: 'TODAY',
  'Toggle Accordion': 'Toggle Accordion',
  'Toggle Menu': 'Toggle Menu',
  'Total Operator Labor Costs': 'Total Operator Labor Costs',
  'Up or down arrow keys': 'Up or down arrow keys',
  'USA & Canada Region': 'USA & Canada Region',
  'Yes': 'Yes',
  'Your Host': 'Your Host',
  'Your Hosts': 'Your Hosts',
  'Utility menu': 'utility menu',
};
